//GET_APP_TRACK_LIST
export const GET_MANAGER_APP_TRACK_LIST_REQUEST = 'GET_MANAGER_APP_TRACK_LIST_REQUEST';
export const GET_MANAGER_APP_TRACK_LIST_SUCCESS = 'GET_MANAGER_APP_TRACK_LIST_SUCCESS';
export const GET_MANAGER_APP_TRACK_LIST_FAIL = 'GET_MANAGER_APP_TRACK_LIST_FAIL';

//GET_APP_TRACK_BY_DEP_LIST
export const GET_MANAGER_APP_TRACK_BY_DEP_LIST_REQUEST = 'GET_MANAGER_APP_TRACK_BY_DEP_LIST_REQUEST';
export const GET_MANAGER_APP_TRACK_BY_DEP_LIST_SUCCESS = 'GET_MANAGER_APP_TRACK_BY_DEP_LIST_SUCCESS';
export const GET_MANAGER_APP_TRACK_BY_DEP_LIST_FAIL = 'GET_MANAGER_APP_TRACK_BY_DEP_LIST_FAIL';

//GET_APP_TRACK_BY_DATE_LIST
export const GET_MANAGER_APP_TRACK_BY_DATE_LIST_REQUEST = 'GET_MANAGER_APP_TRACK_BY_DATE_LIST_REQUEST';
export const GET_MANAGER_APP_TRACK_BY_DATE_LIST_SUCCESS = 'GET_MANAGER_APP_TRACK_BY_DATE_LIST_SUCCESS';
export const GET_MANAGER_APP_TRACK_BY_DATE_LIST_FAIL = 'GET_MANAGER_APP_TRACK_BY_DATE_LIST_FAIL';